export const POSTS_PER_PAGE = 9
export const signature = {
  encrypt_key: process.env.NEXT_PUBLIC_EPAY_ENCRYPT_KEY || '9876543210ABCDEF76543210',
  key: process.env.NEXT_PUBLIC_EPAY_KEY || 'BOOKING_ENGINE',
  customer_code: process.env.NEXT_PUBLIC_EPAY_CUSTOMER_CODE || '0993',
}
